import { render } from "./salary_admin_detail.vue?vue&type=template&id=e6e036d8&scoped=true"
import script from "./salary_admin_detail.vue?vue&type=script&lang=js"
export * from "./salary_admin_detail.vue?vue&type=script&lang=js"

import "./salary_admin_detail.vue?vue&type=style&index=0&id=e6e036d8&scoped=true&lang=css"
import "./salary_admin_detail.vue?vue&type=style&index=1&id=e6e036d8&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6e036d8"]])

export default __exports__